/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export enum AcquisitionType {
  CONSIGNMENT = 'CONSIGNMENT',
  PURCHASE = 'PURCHASE'
}

export enum ActionType {
  NEW_SEASON = 'NEW_SEASON',
  SALE = 'SALE'
}

export type Agency = {
  __typename?: 'Agency';
  emails?: Maybe<OrganizationEmails>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AgencyStockState = {
  __typename?: 'AgencyStockState';
  agency: Scalars['String']['output'];
  complimentary?: Maybe<StockAmount>;
  inTransit?: Maybe<Array<ReservedTransitStock>>;
  /** Reserved stock for transit */
  reservedTransit?: Maybe<Array<ReservedTransitStock>>;
  /** Reserved stock for sale */
  saleReserved?: Maybe<StockAmount>;
};

export enum AnalyticsTimeMode {
  CURRENT = 'CURRENT',
  NEXT_MONTH = 'NEXT_MONTH',
  NEXT_TWO_MONTHS = 'NEXT_TWO_MONTHS',
  NEXT_TWO_WEEKS = 'NEXT_TWO_WEEKS',
  NEXT_WEEK = 'NEXT_WEEK'
}

export type AssignClientInput = {
  commercialExecutiveId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type AssignGoalInput = {
  commercialExecutiveId: Scalars['Int']['input'];
  contributionGoal?: InputMaybe<Scalars['Float']['input']>;
  goal?: InputMaybe<Scalars['Float']['input']>;
  /** e.g. 2024-06 */
  yearMonth: Scalars['String']['input'];
};

export type AssignGoalMutationResponse = MutationResponseInterface & {
  __typename?: 'AssignGoalMutationResponse';
  assignedGoal?: Maybe<OrganizationUserGoal>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Balance = {
  __typename?: 'Balance';
  amount: Scalars['Float']['output'];
  currency: Currency;
};

export type CalendarDateV2 = {
  __typename?: 'CalendarDateV2';
  date: Scalars['String']['output'];
  daysSinceEmergence?: Maybe<Scalars['Int']['output']>;
  indicators?: Maybe<CalendarIndicators>;
  mapUrls: MapUrls;
};

export type CalendarDateV3 = {
  __typename?: 'CalendarDateV3';
  date: Scalars['String']['output'];
  daysSinceEmergence?: Maybe<Scalars['Int']['output']>;
  mapUrls: MapUrlsV3;
};

export type CalendarIndexLot = {
  __typename?: 'CalendarIndexLot';
  cropId?: Maybe<Scalars['Int']['output']>;
  daysSinceEmergence?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lotId: Scalars['Int']['output'];
  providers: Array<CalendarProvider>;
  varietyId?: Maybe<Scalars['Int']['output']>;
};

export type CalendarIndicators = {
  __typename?: 'CalendarIndicators';
  chlorophyll?: Maybe<IndicatorStatus>;
  irrigation?: Maybe<IndicatorStatus>;
};

export type CalendarIndices = {
  __typename?: 'CalendarIndices';
  chlorophyll?: Maybe<Array<CalendarIndexLot>>;
  emergence?: Maybe<Array<CalendarIndexLot>>;
  grainHumidity?: Maybe<Array<CalendarIndexLot>>;
  irrigation?: Maybe<Array<CalendarIndexLot>>;
  realImage?: Maybe<Array<CalendarIndexLot>>;
  water?: Maybe<Array<CalendarIndexLot>>;
  weeds?: Maybe<Array<CalendarIndexLot>>;
};

export type CalendarProvider = {
  __typename?: 'CalendarProvider';
  colorHistogram?: Maybe<Array<ColorHistogramValue>>;
  id: Scalars['String']['output'];
  indicator?: Maybe<IndicatorStatus>;
  isAvailable: Scalars['Boolean']['output'];
  provider: SentinelHubProvider;
  url?: Maybe<Scalars['String']['output']>;
  weatherType?: Maybe<WeatherType>;
};

export type ChangeOrgRoleMutationResponse = MutationResponseInterface & {
  __typename?: 'ChangeOrgRoleMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  orgUser: UserOrgRole;
  success: Scalars['Boolean']['output'];
};

export type ClientLot = {
  __typename?: 'ClientLot';
  commercialId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  size?: Maybe<Scalars['Float']['output']>;
};

export type ClientSale = {
  __typename?: 'ClientSale';
  commercialExecutiveName?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  hasCreditNote: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lot?: Maybe<SaleLot>;
  measureUnit: StockProductUnit;
  products: Array<SaleProduct>;
  total: Scalars['Float']['output'];
  totalContributions?: Maybe<Scalars['Float']['output']>;
  /** This value is the sum between "totalWeight" and "totalVolume" */
  totalMeasure: Scalars['Float']['output'];
  totalVolume: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
};

export type ClientSalesStatistics = {
  __typename?: 'ClientSalesStatistics';
  contributionPercentage?: Maybe<Scalars['Float']['output']>;
  lastSaleDate?: Maybe<Scalars['String']['output']>;
  measureUnit: StockProductUnit;
  total: Scalars['Float']['output'];
  totalContributions?: Maybe<Scalars['Float']['output']>;
  /** This value is the sum between "totalWeight" and "totalVolume" */
  totalMeasure: Scalars['Float']['output'];
  totalVolume: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
};

export type ClientWithSales = {
  __typename?: 'ClientWithSales';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sales: Array<ClientSale>;
  statistics: ClientSalesStatistics;
};

export type ClientsSales = {
  __typename?: 'ClientsSales';
  clients: Array<ClientWithSales>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ColorHistogramValue = {
  __typename?: 'ColorHistogramValue';
  area: Scalars['Float']['output'];
  color: Scalars['String']['output'];
};

export enum CommercialEventType {
  MILESTONE = 'MILESTONE',
  RECOMMENDATION = 'RECOMMENDATION'
}

export type CommercialEventV2 = {
  __typename?: 'CommercialEventV2';
  commercialTrigger: CommercialTrigger;
  company: CompanyInfo;
  daysSinceEmergence?: Maybe<Scalars['Int']['output']>;
  expirationDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  lot: LotInfo;
  milestoneDate?: Maybe<Scalars['String']['output']>;
  potentialTotal?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['String']['output'];
  status: Status;
  type: CommercialEventType;
};

export type CommercialEventV3 = {
  __typename?: 'CommercialEventV3';
  company: CompanyInfo;
  expirationDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lot: LotInfoV2;
  milestoneInfo?: Maybe<MilestoneInfo>;
  recommendationInfo?: Maybe<RecommendationInfo>;
  startDate: Scalars['String']['output'];
  status: Status;
  type: CommercialEventType;
};

export type CommercialItem = {
  __typename?: 'CommercialItem';
  id: Scalars['Int']['output'];
  line?: Maybe<CommercialLine>;
  name: Scalars['String']['output'];
  potentialAmount?: Maybe<Scalars['Int']['output']>;
};

export enum CommercialLine {
  FERTILIZER = 'FERTILIZER',
  OTHER = 'OTHER',
  PHYTOSANITARY = 'PHYTOSANITARY',
  SEEDS = 'SEEDS'
}

export type CommercialProduct = {
  __typename?: 'CommercialProduct';
  id: Scalars['Int']['output'];
  line?: Maybe<CommercialLine>;
  name: Scalars['String']['output'];
  unit: CommercialUnit;
};

export type CommercialProducts = {
  __typename?: 'CommercialProducts';
  results: Array<CommercialProduct>;
};

export type CommercialTrigger = {
  __typename?: 'CommercialTrigger';
  actionType: ActionType;
  commercialItems?: Maybe<Array<CommercialItem>>;
  expirationDays: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  milestone: RiceLotStatus;
  timelapseAmount?: Maybe<Scalars['Int']['output']>;
  timelapseMoment: TimelapseMoment;
  timelapseType?: Maybe<TimelapseType>;
};

export enum CommercialUnit {
  KILOGRAMS = 'KILOGRAMS',
  LITERS = 'LITERS'
}

export type Companies = {
  __typename?: 'Companies';
  results: Array<Company>;
};

export type CompaniesPage = PageInterface & {
  __typename?: 'CompaniesPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<Company>;
  resultsTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Company = {
  __typename?: 'Company';
  balance?: Maybe<CompanyBalance>;
  country: CountryType;
  createdAt: Scalars['DateTime']['output'];
  externalAccountId?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Field>>;
  governmentId?: Maybe<Scalars['String']['output']>;
  governmentIdType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invitations: Array<Invitation>;
  irrigationWorkersAccessMode: IrrigationWorkersAccessMode;
  isVerified: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  milestonesTimeline: Array<RiceLotStatus>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  /** @deprecated Use "phoneNumbers" field instead */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
  satelliteImageryFlag: Scalars['Boolean']['output'];
  seasons?: Maybe<Array<CompanySeason>>;
  subregion?: Maybe<Subregion>;
  subregionId?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usersRoles?: Maybe<Array<UserRole>>;
};

export type CompanyAnalytics = {
  __typename?: 'CompanyAnalytics';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CompanyBalance = {
  __typename?: 'CompanyBalance';
  dollarBalance: Balance;
  localBalance: Balance;
};

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  country: CountryType;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** @deprecated Use "phoneNumbers" field instead */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CompanyMutationResponse = MutationResponseInterface & {
  __typename?: 'CompanyMutationResponse';
  code: Scalars['String']['output'];
  company: Company;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CompanyRole = {
  __typename?: 'CompanyRole';
  company: Company;
  role: UserCompanyRole;
};

export type CompanySeason = {
  __typename?: 'CompanySeason';
  commercialExecutive?: Maybe<User>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  seasonFields?: Maybe<Array<CompanySeasonField>>;
  startDate: Scalars['String']['output'];
};

export type CompanySeasonField = {
  __typename?: 'CompanySeasonField';
  field?: Maybe<Field>;
  id: Scalars['Int']['output'];
  lots?: Maybe<Array<CompanySeasonFieldLot>>;
};

export type CompanySeasonFieldLot = {
  __typename?: 'CompanySeasonFieldLot';
  crop: Crop;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** In ha */
  size: Scalars['Float']['output'];
};

export type ComplimentaryStockData = {
  __typename?: 'ComplimentaryStockData';
  measure?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
};

export type CostByAcquisitionType = {
  __typename?: 'CostByAcquisitionType';
  consignment?: Maybe<CostData>;
  purchase?: Maybe<CostData>;
};

export type CostData = {
  __typename?: 'CostData';
  cost: Scalars['Float']['output'];
  date: Scalars['String']['output'];
};

export type Countries = {
  __typename?: 'Countries';
  results: Array<Country>;
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  id: CountryId;
  name: Scalars['String']['output'];
};

export enum CountryId {
  ARGENTINA = 'ARGENTINA',
  BRAZIL = 'BRAZIL',
  COLOMBIA = 'COLOMBIA',
  DOMINICAN_REPUBLIC = 'DOMINICAN_REPUBLIC',
  PANAMA = 'PANAMA',
  PARAGUAY = 'PARAGUAY',
  UNITED_STATES = 'UNITED_STATES',
  URUGUAY = 'URUGUAY'
}

export type CountryType = {
  __typename?: 'CountryType';
  code: Scalars['String']['output'];
  id: CountryId;
  /** ISO 3166-2 */
  isoCode: Scalars['String']['output'];
  lng: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateCompanyInput = {
  country: CountryId;
  governmentId?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  subregionId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDamDto = {
  area: PolygonInput;
  name: Scalars['String']['input'];
};

export type CreateDamInput = {
  area: PolygonInput;
  fieldId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateFieldInput = {
  companyId: Scalars['Int']['input'];
  createDamsDTOs?: InputMaybe<Array<CreateDamDto>>;
  deliveryCondition?: InputMaybe<DeliveryCondition>;
  directions?: InputMaybe<Scalars['String']['input']>;
  location: PointInput;
  name: Scalars['String']['input'];
  productionType?: InputMaybe<ProductionType>;
};

export type CreateLotInput = {
  area?: InputMaybe<PolygonInput>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  cropId: Scalars['Int']['input'];
  fieldId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  previousCropId?: InputMaybe<Scalars['Int']['input']>;
  rtk?: InputMaybe<MultiLineStringInput>;
  seasonId: Scalars['Int']['input'];
  /** In ha */
  size?: InputMaybe<Scalars['Float']['input']>;
  templateLotId?: InputMaybe<Scalars['Int']['input']>;
  varietyId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOrganizationOrderInput = {
  client: OrderClientInput;
  deliveryType: DeliveryType;
  emails: Array<Scalars['String']['input']>;
  lots: Array<OrderLotInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupAgency?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRecommendationInput = {
  client: RecommendationClientInput;
  lotName: Scalars['String']['input'];
  /** In ha */
  lotSize: Scalars['Float']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  products: Array<RecommendationProductInput>;
};

export type CreateRiceAppliedFertilizerInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  fertilizerGrades?: InputMaybe<Array<FertilizerGradeInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  riceLotId: Scalars['Int']['input'];
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRiceAppliedPhytosanitaryInput = {
  activeIngredients?: InputMaybe<Array<Scalars['Int']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  riceLotId: Scalars['Int']['input'];
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSeasonInput = {
  companyId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  millDeliveryType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productionToMill?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  profilePicture?: InputMaybe<Scalars['Upload']['input']>;
};

export type Crop = {
  __typename?: 'Crop';
  id: Scalars['Int']['output'];
  locales: LocalesType;
  name: Scalars['String']['output'];
};

export type Crops = {
  __typename?: 'Crops';
  results: Array<Crop>;
};

export enum Currency {
  ARS = 'ARS',
  USD = 'USD'
}

export type CurveValue = {
  __typename?: 'CurveValue';
  chlorophyll: Scalars['Float']['output'];
  daysSinceEmergence: Scalars['Int']['output'];
};

export type CycleStageDays = {
  __typename?: 'CycleStageDays';
  LONG?: Maybe<RiceLotStages>;
  LONG_72_130?: Maybe<RiceLotStages>;
  LONG_75_125?: Maybe<RiceLotStages>;
  LONG_80_120?: Maybe<RiceLotStages>;
  LONG_90_125?: Maybe<RiceLotStages>;
  LONG_90_150?: Maybe<RiceLotStages>;
  LONG_92_130?: Maybe<RiceLotStages>;
  LONG_96_133?: Maybe<RiceLotStages>;
  LONG_100_140?: Maybe<RiceLotStages>;
  LONG_103_134?: Maybe<RiceLotStages>;
  MEDIUM?: Maybe<RiceLotStages>;
  MEDIUM_68_120?: Maybe<RiceLotStages>;
  MEDIUM_72_110?: Maybe<RiceLotStages>;
  MEDIUM_72_115?: Maybe<RiceLotStages>;
  MEDIUM_85_115?: Maybe<RiceLotStages>;
  MEDIUM_94_115?: Maybe<RiceLotStages>;
  SHORT?: Maybe<RiceLotStages>;
  SHORT_68_95?: Maybe<RiceLotStages>;
  SHORT_68_100?: Maybe<RiceLotStages>;
  SHORT_68_105?: Maybe<RiceLotStages>;
};

export type CycleStageDaysInput = {
  LONG?: InputMaybe<RiceLotStagesInput>;
  LONG_72_130?: InputMaybe<RiceLotStagesInput>;
  LONG_75_125?: InputMaybe<RiceLotStagesInput>;
  LONG_80_120?: InputMaybe<RiceLotStagesInput>;
  LONG_90_125?: InputMaybe<RiceLotStagesInput>;
  LONG_90_150?: InputMaybe<RiceLotStagesInput>;
  LONG_92_130?: InputMaybe<RiceLotStagesInput>;
  LONG_96_133?: InputMaybe<RiceLotStagesInput>;
  LONG_100_140?: InputMaybe<RiceLotStagesInput>;
  LONG_103_134?: InputMaybe<RiceLotStagesInput>;
  MEDIUM?: InputMaybe<RiceLotStagesInput>;
  MEDIUM_68_120?: InputMaybe<RiceLotStagesInput>;
  MEDIUM_72_110?: InputMaybe<RiceLotStagesInput>;
  MEDIUM_72_115?: InputMaybe<RiceLotStagesInput>;
  MEDIUM_85_115?: InputMaybe<RiceLotStagesInput>;
  MEDIUM_94_115?: InputMaybe<RiceLotStagesInput>;
  SHORT?: InputMaybe<RiceLotStagesInput>;
  SHORT_68_95?: InputMaybe<RiceLotStagesInput>;
  SHORT_68_100?: InputMaybe<RiceLotStagesInput>;
  SHORT_68_105?: InputMaybe<RiceLotStagesInput>;
};

export type Dam = {
  __typename?: 'Dam';
  area: PolygonType;
  calendar: Array<DamCalendarDate>;
  fieldId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  indicators?: Maybe<DamIndicators>;
  location: PointType;
  name: Scalars['String']['output'];
  /** In ha */
  size: Scalars['Float']['output'];
};


export type DamCalendarArgs = {
  fromYearMonth?: InputMaybe<Scalars['String']['input']>;
  toYearMonth?: InputMaybe<Scalars['String']['input']>;
};

export type DamCalendarDate = {
  __typename?: 'DamCalendarDate';
  date: Scalars['String']['output'];
  mapUrls: DamMapUrls;
};

export type DamCalendarIndex = {
  __typename?: 'DamCalendarIndex';
  damId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  providers: Array<DamProvider>;
};

export type DamCalendarIndices = {
  __typename?: 'DamCalendarIndices';
  waterSurface?: Maybe<Array<DamCalendarIndex>>;
};

export type DamIndicators = {
  __typename?: 'DamIndicators';
  lastUpdate: Scalars['DateTime']['output'];
  /** unit: square meters */
  waterSurfaceArea?: Maybe<Scalars['Int']['output']>;
  waterSurfacePercentage?: Maybe<Scalars['Int']['output']>;
  waterSurfaceVolume?: Maybe<Scalars['Int']['output']>;
};

export type DamMapUrls = {
  __typename?: 'DamMapUrls';
  waterSurface?: Maybe<WaterSurfaceMapIndex>;
};

export type DamMutationResponse = MutationResponseInterface & {
  __typename?: 'DamMutationResponse';
  code: Scalars['String']['output'];
  dam: Dam;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DamProvider = {
  __typename?: 'DamProvider';
  /** unit: square meters */
  area?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  percentage?: Maybe<Scalars['Int']['output']>;
  provider: SentinelHubProvider;
  url?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
  weatherType?: Maybe<WeatherType>;
};

export type Dams = {
  __typename?: 'Dams';
  results: Array<Dam>;
};

export type DatePriceHistory = {
  __typename?: 'DatePriceHistory';
  cost?: Maybe<Scalars['Float']['output']>;
  date: Scalars['String']['output'];
  displayFullDate: Scalars['String']['output'];
  displayShortDate: Scalars['String']['output'];
  maxPrice: PriceHistoryData;
  meanPrice: Scalars['Float']['output'];
  minPrice: PriceHistoryData;
};

export type DateRange = {
  __typename?: 'DateRange';
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type DateRangeInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export enum DeliveryCondition {
  DRY = 'DRY',
  WET = 'WET'
}

export type DeliveryConditionYield = {
  __typename?: 'DeliveryConditionYield';
  deliveryCondition: DeliveryCondition;
  value: Scalars['Int']['output'];
};

export enum DeliveryType {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
  SUPPLY_DELIVERY = 'SUPPLY_DELIVERY'
}

export type Emails = {
  __typename?: 'Emails';
  mandatory: Array<Scalars['String']['output']>;
  optionals: Array<Scalars['String']['output']>;
};

export type EmergenceDaysActivationIndices = {
  __typename?: 'EmergenceDaysActivationIndices';
  emergence: Scalars['Int']['output'];
  grainHumidity: Scalars['Int']['output'];
  water?: Maybe<Scalars['Int']['output']>;
  weeds: Scalars['Int']['output'];
};

export type EstimatedYield = {
  __typename?: 'EstimatedYield';
  chlorophyllPeakDate?: Maybe<Scalars['DateTime']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  /** In Kg */
  lotValue?: Maybe<Scalars['Float']['output']>;
  mapUrl?: Maybe<Scalars['String']['output']>;
  noFormula?: Maybe<Scalars['Boolean']['output']>;
  /** In Kg */
  value?: Maybe<Scalars['Float']['output']>;
};

export type ExpirationByAgency = {
  __typename?: 'ExpirationByAgency';
  agency: Scalars['String']['output'];
  expirations?: Maybe<Expirations>;
};

export type ExpirationDateAmount = {
  __typename?: 'ExpirationDateAmount';
  date: Scalars['String']['output'];
  measure?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type ExpirationStockAmount = {
  __typename?: 'ExpirationStockAmount';
  expirationDates?: Maybe<Array<ExpirationDateAmount>>;
  measure?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
};

export type Expirations = {
  __typename?: 'Expirations';
  expired?: Maybe<ExpirationStockAmount>;
  long?: Maybe<ExpirationStockAmount>;
  medium?: Maybe<ExpirationStockAmount>;
  short?: Maybe<ExpirationStockAmount>;
};

export type ExternalUnit = {
  __typename?: 'ExternalUnit';
  externalUnits: Array<Scalars['String']['output']>;
  unit: StockProductUnit;
};

export type ExternalUnitsMutationResponse = MutationResponseInterface & {
  __typename?: 'ExternalUnitsMutationResponse';
  code: Scalars['String']['output'];
  externalUnits: Array<ExternalUnit>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  updatedProductsIds: Array<Scalars['Float']['output']>;
};

export enum FeatureSet {
  GRUPO_DIANA = 'GRUPO_DIANA'
}

export type FertilizerGrade = {
  __typename?: 'FertilizerGrade';
  grade?: Maybe<Scalars['Float']['output']>;
  nutrient?: Maybe<RiceNutrient>;
};

export type FertilizerGradeInput = {
  grade?: InputMaybe<Scalars['Float']['input']>;
  nutrientId?: InputMaybe<Scalars['Int']['input']>;
};

export type Field = {
  __typename?: 'Field';
  createdAt: Scalars['DateTime']['output'];
  dams: Array<Dam>;
  deliveryCondition: DeliveryCondition;
  directions?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  location: PointType;
  name: Scalars['String']['output'];
  productionType: ProductionType;
  updatedAt: Scalars['DateTime']['output'];
  weather?: Maybe<Weather>;
};


export type FieldWeatherArgs = {
  fromDate: Scalars['DateTime']['input'];
};

export type FieldDamCalendarDate = {
  __typename?: 'FieldDamCalendarDate';
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  indices: DamCalendarIndices;
};

export type FieldDamsCalendar = {
  __typename?: 'FieldDamsCalendar';
  dates: Array<FieldDamCalendarDate>;
};

export type FieldMutationResponse = MutationResponseInterface & {
  __typename?: 'FieldMutationResponse';
  code: Scalars['String']['output'];
  field: Field;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Fields = {
  __typename?: 'Fields';
  results: Array<Field>;
};

export type Fortnights = {
  __typename?: 'Fortnights';
  dateRange: DateRange;
  name: Scalars['String']['output'];
};

export type FortnightsData = {
  __typename?: 'FortnightsData';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type FortnightsStats = {
  __typename?: 'FortnightsStats';
  /** value in Ha */
  byArea: Array<FortnightsData>;
  /** value in Kg */
  byYield: Array<FortnightsData>;
};

export type GrainHumidity = {
  __typename?: 'GrainHumidity';
  /** If indicator is not available and this field is null, it means system need to wait for an image with grain humidity histogram to make it available */
  emergenceDaysActivation?: Maybe<Scalars['Int']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  lastUpdate?: Maybe<Scalars['DateTime']['output']>;
  levels?: Maybe<GrainHumidityLevels>;
};

export type GrainHumidityBin = {
  __typename?: 'GrainHumidityBin';
  highEdge: Scalars['Float']['output'];
  lowEdge: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
};

export type GrainHumidityLevels = {
  __typename?: 'GrainHumidityLevels';
  five: GrainHumidityBin;
  four: GrainHumidityBin;
  one: GrainHumidityBin;
  seven: GrainHumidityBin;
  six: GrainHumidityBin;
  three: GrainHumidityBin;
  two: GrainHumidityBin;
};

export enum GrainType {
  CRYSTAL_MEDIUM = 'CRYSTAL_MEDIUM',
  LONG = 'LONG',
  NO_TYPE = 'NO_TYPE',
  PEARL_MEDIUM = 'PEARL_MEDIUM',
  SHORT = 'SHORT'
}

export type HistoricalIrrigation = {
  __typename?: 'HistoricalIrrigation';
  values: Array<HistoricalIrrigationValue>;
};

export type HistoricalIrrigationValue = {
  __typename?: 'HistoricalIrrigationValue';
  date: Scalars['String']['output'];
  daysSinceEmergence: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type HistoricalSale = {
  __typename?: 'HistoricalSale';
  yearMonth: Scalars['String']['output'];
};

export type HistoricalSales = {
  __typename?: 'HistoricalSales';
  history: Array<HistoricalSale>;
};

export type HistoricalSeasons = {
  __typename?: 'HistoricalSeasons';
  endRange: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startRange: Scalars['String']['output'];
};

export type InTransitStock = {
  __typename?: 'InTransitStock';
  measure?: Maybe<Scalars['Float']['output']>;
  originAgency: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type InTransitStockData = {
  __typename?: 'InTransitStockData';
  stock: Array<InTransitStock>;
  totalMeasure?: Maybe<Scalars['Float']['output']>;
  totalQuantity: Scalars['Int']['output'];
};

export enum IndicatorStatus {
  BAD = 'BAD',
  GOOD = 'GOOD',
  MEDIUM = 'MEDIUM'
}

export type Indicators = {
  __typename?: 'Indicators';
  chlorophyll?: Maybe<IndicatorStatus>;
  grainHumidity?: Maybe<GrainHumidity>;
  irrigation?: Maybe<IndicatorStatus>;
  lastUpdate: Scalars['DateTime']['output'];
  semaphore?: Maybe<IndicatorStatus>;
  sufficientWaterPercentage?: Maybe<Scalars['Float']['output']>;
  weatherType: WeatherType;
};

export type Invitation = {
  __typename?: 'Invitation';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  role: UserCompanyRole;
  updatedAt: Scalars['DateTime']['output'];
};

export type InviteOrgMutationResponse = MutationResponseInterface & {
  __typename?: 'InviteOrgMutationResponse';
  code: Scalars['String']['output'];
  invitation?: Maybe<OrganizationInvitation>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type InviteOrganizationInput = {
  email: Scalars['String']['input'];
  regionId?: InputMaybe<Scalars['Int']['input']>;
  role: UserOrganizationRole;
};

export type InviteUserInput = {
  companyId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  role: UserCompanyRole;
};

export type IrrigationWorker = {
  __typename?: 'IrrigationWorker';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum IrrigationWorkersAccessMode {
  ASSIGNED_LOT = 'ASSIGNED_LOT',
  FIELD = 'FIELD'
}

export type Item = {
  __typename?: 'Item';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LocalesType = {
  __typename?: 'LocalesType';
  en: Scalars['String']['output'];
  es: Scalars['String']['output'];
  pt: Scalars['String']['output'];
};

export type LoginResponse = MutationResponseInterface & {
  __typename?: 'LoginResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  user: User;
};

export type Lot = {
  __typename?: 'Lot';
  /** In ha */
  abandonedSize?: Maybe<Scalars['Float']['output']>;
  area: PolygonType;
  commercialName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  crop: Crop;
  deliveryCondition: DeliveryCondition;
  deliveryMill?: Maybe<Mill>;
  id: Scalars['Int']['output'];
  irrigationWorker?: Maybe<IrrigationWorker>;
  location: PointType;
  name: Scalars['String']['output'];
  previousCrop?: Maybe<Crop>;
  productionType: ProductionType;
  riceLot: RiceLot;
  rtk?: Maybe<MultiLineStringType>;
  /** In ha */
  size: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<Variety>;
};

export type LotInfo = {
  __typename?: 'LotInfo';
  commercialName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** In ha */
  size: Scalars['Float']['output'];
};

export type LotInfoV2 = {
  __typename?: 'LotInfoV2';
  commercialName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** In ha */
  size: Scalars['Float']['output'];
};

export type LotMutationResponse = MutationResponseInterface & {
  __typename?: 'LotMutationResponse';
  code: Scalars['String']['output'];
  lot: LotV2;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type LotV2 = {
  __typename?: 'LotV2';
  /** In ha */
  abandonedSize?: Maybe<Scalars['Float']['output']>;
  area?: Maybe<PolygonType>;
  commercialName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  crop: Crop;
  deliveryCondition: DeliveryCondition;
  deliveryMill?: Maybe<Mill>;
  id: Scalars['Int']['output'];
  irrigationWorker?: Maybe<IrrigationWorker>;
  location?: Maybe<PointType>;
  name: Scalars['String']['output'];
  previousCrop?: Maybe<Crop>;
  productionType: ProductionType;
  riceLot: RiceLot;
  rtk?: Maybe<MultiLineStringType>;
  /** In ha */
  size: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<Variety>;
};

export type Lots = {
  __typename?: 'Lots';
  results: Array<Lot>;
};

export type LotsV2 = {
  __typename?: 'LotsV2';
  results: Array<LotV2>;
};

export type MapIndex = {
  __typename?: 'MapIndex';
  colorHistogram?: Maybe<Array<ColorHistogramValue>>;
  isAvailable: Scalars['Boolean']['output'];
  provider: SentinelHubProvider;
  url?: Maybe<Scalars['String']['output']>;
  weatherType?: Maybe<WeatherType>;
};

export type MapIndexV3 = {
  __typename?: 'MapIndexV3';
  colorHistogram?: Maybe<Array<ColorHistogramValue>>;
  indicator?: Maybe<IndicatorStatus>;
  isAvailable: Scalars['Boolean']['output'];
  provider: SentinelHubProvider;
  url?: Maybe<Scalars['String']['output']>;
  weatherType?: Maybe<WeatherType>;
};

export type MapIndexWithActivation = {
  __typename?: 'MapIndexWithActivation';
  colorHistogram?: Maybe<Array<ColorHistogramValue>>;
  emergenceDaysActivation: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  provider: SentinelHubProvider;
  url?: Maybe<Scalars['String']['output']>;
  weatherType?: Maybe<WeatherType>;
};

export type MapIndexWithActivationV3 = {
  __typename?: 'MapIndexWithActivationV3';
  colorHistogram?: Maybe<Array<ColorHistogramValue>>;
  emergenceDaysActivation: Scalars['Int']['output'];
  indicator?: Maybe<IndicatorStatus>;
  isAvailable: Scalars['Boolean']['output'];
  provider: SentinelHubProvider;
  url?: Maybe<Scalars['String']['output']>;
  weatherType?: Maybe<WeatherType>;
};

export type MapUrls = {
  __typename?: 'MapUrls';
  chlorophyll?: Maybe<MapIndex>;
  emergence?: Maybe<MapIndexWithActivation>;
  grainHumidity?: Maybe<MapIndexWithActivation>;
  irrigation?: Maybe<MapIndex>;
  realImage?: Maybe<MapIndex>;
  water?: Maybe<MapIndexWithActivation>;
  weeds?: Maybe<MapIndexWithActivation>;
};

export type MapUrlsV3 = {
  __typename?: 'MapUrlsV3';
  chlorophyll?: Maybe<Array<MapIndexV3>>;
  emergence?: Maybe<Array<MapIndexWithActivationV3>>;
  grainHumidity?: Maybe<Array<MapIndexWithActivationV3>>;
  irrigation?: Maybe<Array<MapIndexV3>>;
  realImage?: Maybe<Array<MapIndexV3>>;
  water?: Maybe<Array<MapIndexWithActivationV3>>;
  weeds?: Maybe<Array<MapIndexWithActivationV3>>;
};

export type MilestoneInfo = {
  __typename?: 'MilestoneInfo';
  commercialTrigger: CommercialTrigger;
  daysSinceEmergence?: Maybe<Scalars['Int']['output']>;
  milestoneDate?: Maybe<Scalars['String']['output']>;
  potentialTotal?: Maybe<Scalars['Int']['output']>;
};

export enum MilestoneUpdateType {
  AUTOMATIC_CONVERSION = 'AUTOMATIC_CONVERSION',
  AUTOMATIC_SENTINEL1 = 'AUTOMATIC_SENTINEL1',
  MANUAL = 'MANUAL'
}

export type Mill = {
  __typename?: 'Mill';
  id: Scalars['Int']['output'];
  location: PointType;
  name: Scalars['String']['output'];
};

export type MultiLineStringInput = {
  coordinates: Array<Array<Array<Scalars['Float']['input']>>>;
  type?: Scalars['String']['input'];
};

export type MultiLineStringType = {
  __typename?: 'MultiLineStringType';
  coordinates: Array<Array<Array<Scalars['Float']['output']>>>;
  type: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  assignClient: MutationResponseInterface;
  assignCommercialExecutiveGoal: AssignGoalMutationResponse;
  changeOrgUserRole: ChangeOrgRoleMutationResponse;
  changeUserRole: CompanyMutationResponse;
  createCompany: CompanyMutationResponse;
  createDam: DamMutationResponse;
  createDams: Dams;
  createField: FieldMutationResponse;
  createLot: LotMutationResponse;
  createLots: LotsV2;
  createOrder: OrganizationOrderMutationResponse;
  createRecommendation: RecommendationMutationResponse;
  createRiceFertilizer: RiceAppliedFertilizerMutationResponse;
  createRicePhytosanitary: RiceAppliedPhytosanitaryMutationResponse;
  createSeason: SeasonMutationResponse;
  createUser: UserMutationResponse;
  deleteCompany: UserMutationResponse;
  deleteDam: MutationResponseInterface;
  deleteField: MutationResponseInterface;
  deleteInvitation: MutationResponseInterface;
  deleteLot: MutationResponseInterface;
  deleteRiceFertilizer: MutationResponseInterface;
  deleteRicePhytosanitary: MutationResponseInterface;
  deleteSeason: MutationResponseInterface;
  deleteUser: MutationResponseInterface;
  inviteOrganizationUser: InviteOrgMutationResponse;
  inviteUser: CompanyMutationResponse;
  leaveCompany: UserMutationResponse;
  login: LoginResponse;
  loginWithToken: LoginResponse;
  reingestLotsImagesMetadata: MutationResponseInterface;
  requestPasswordChange: MutationResponseInterface;
  resendInvitation: MutationResponseInterface;
  resendOrganizationInvitation: InviteOrgMutationResponse;
  signup: SignupResponse;
  updateCompany: CompanyMutationResponse;
  updateDam: DamMutationResponse;
  updateDams: Dams;
  updateErpIntegrationMeasureUnitMap: ExternalUnitsMutationResponse;
  updateField: FieldMutationResponse;
  updateLot: LotMutationResponse;
  updateLots: LotsV2;
  updateLotsMilestoneTimelines: MutationResponseInterface;
  updateLotsRadarMilestoneTimelines: MutationResponseInterface;
  updateOrganization: OrganizationMutationResponse;
  updateOrganizationUser: UpdateOrganizationUserMutationResponse;
  updateRegionCrops: RegionCropMutationResponse;
  updateRiceFertilizer: RiceAppliedFertilizerMutationResponse;
  updateRiceLot: RiceLotMutationResponse;
  updateRicePhytosanitary: RiceAppliedPhytosanitaryMutationResponse;
  updateSeason: SeasonMutationResponse;
  updateUser: UserMutationResponse;
  validatePasswordChange: LoginResponse;
  verifyAccount: MutationResponseInterface;
};


export type MutationAssignClientArgs = {
  assignClientDTO: AssignClientInput;
};


export type MutationAssignCommercialExecutiveGoalArgs = {
  assignGoalDTO: AssignGoalInput;
};


export type MutationChangeOrgUserRoleArgs = {
  role: UserOrganizationRole;
  userId: Scalars['Int']['input'];
};


export type MutationChangeUserRoleArgs = {
  companyId: Scalars['Int']['input'];
  role: UserCompanyRole;
  userId: Scalars['Int']['input'];
};


export type MutationCreateCompanyArgs = {
  createCompanyDTO: CreateCompanyInput;
  founderId: Scalars['Int']['input'];
};


export type MutationCreateDamArgs = {
  createDamDto: CreateDamInput;
};


export type MutationCreateDamsArgs = {
  createDamDTOs: Array<CreateDamInput>;
};


export type MutationCreateFieldArgs = {
  createFieldDTO: CreateFieldInput;
};


export type MutationCreateLotArgs = {
  createLotDTO: CreateLotInput;
};


export type MutationCreateLotsArgs = {
  createLotDTOs: Array<CreateLotInput>;
};


export type MutationCreateOrderArgs = {
  createOrganizationOrderDTO: CreateOrganizationOrderInput;
};


export type MutationCreateRecommendationArgs = {
  createRecommendationDTO: CreateRecommendationInput;
};


export type MutationCreateRiceFertilizerArgs = {
  createFertilizerDTO: CreateRiceAppliedFertilizerInput;
};


export type MutationCreateRicePhytosanitaryArgs = {
  createPhytosanitaryDTO: CreateRiceAppliedPhytosanitaryInput;
};


export type MutationCreateSeasonArgs = {
  createSeasonDTO: CreateSeasonInput;
};


export type MutationCreateUserArgs = {
  createUserDTO: CreateUserInput;
  locale?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteDamArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFieldArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvitationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteLotArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteRiceFertilizerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteRicePhytosanitaryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteSeasonArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['Int']['input'];
};


export type MutationInviteOrganizationUserArgs = {
  inviteOrgUserDTO: InviteOrganizationInput;
};


export type MutationInviteUserArgs = {
  inviteUserDTO: InviteUserInput;
};


export type MutationLeaveCompanyArgs = {
  companyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationLoginWithTokenArgs = {
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReingestLotsImagesMetadataArgs = {
  from: Scalars['DateTime']['input'];
  providers: Array<SentinelHubProvider>;
  to: Scalars['DateTime']['input'];
};


export type MutationRequestPasswordChangeArgs = {
  email: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResendInvitationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationResendOrganizationInvitationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSignupArgs = {
  createUserDTO: CreateUserInput;
  locale?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['Int']['input'];
  updateCompanyDTO: UpdateCompanyInput;
};


export type MutationUpdateDamArgs = {
  updateDamDTO: UpdateDamInput;
};


export type MutationUpdateDamsArgs = {
  updateDamsArgs: Array<UpdateDamInput>;
};


export type MutationUpdateErpIntegrationMeasureUnitMapArgs = {
  integrationId: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
  updateUnitMeasureMapInput: UpdateUnitMeasureMapInput;
};


export type MutationUpdateFieldArgs = {
  id: Scalars['Int']['input'];
  updateFieldDTO: UpdateFieldInput;
};


export type MutationUpdateLotArgs = {
  updateLotDTO: UpdateLotInput;
};


export type MutationUpdateLotsArgs = {
  updateLotDTOs: Array<UpdateLotInput>;
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['Int']['input'];
  updateOrganizationDTO: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationUserArgs = {
  regionId?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<UserOrganizationRole>;
  userId: Scalars['Int']['input'];
};


export type MutationUpdateRegionCropsArgs = {
  id: Scalars['Int']['input'];
  updateRegionCropDTO: UpdateRegionCropInput;
};


export type MutationUpdateRiceFertilizerArgs = {
  id: Scalars['Int']['input'];
  updateFertilizerDTO: UpdateRiceAppliedFertilizerInput;
};


export type MutationUpdateRiceLotArgs = {
  id: Scalars['Int']['input'];
  updateRiceLotDTO: UpdateRiceLotInput;
};


export type MutationUpdateRicePhytosanitaryArgs = {
  id: Scalars['Int']['input'];
  updatePhytosanitaryDTO: UpdateRiceAppliedPhytosanitaryInput;
};


export type MutationUpdateSeasonArgs = {
  id: Scalars['Int']['input'];
  updateSeasonDTO: UpdateSeasonInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['Int']['input'];
  updateUserDTO: UpdateUserInput;
};


export type MutationValidatePasswordChangeArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationVerifyAccountArgs = {
  token: Scalars['String']['input'];
};

export type MutationResponseInterface = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MutationResponseType = MutationResponseInterface & {
  __typename?: 'MutationResponseType';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type NullableEndDateRangeInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export enum Order {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type OrderAgencyProductSummary = {
  __typename?: 'OrderAgencyProductSummary';
  /** @deprecated Use "brandV2" field instead */
  brand: Scalars['String']['output'];
  brandV2?: Maybe<Scalars['String']['output']>;
  line?: Maybe<CommercialLine>;
  name: Scalars['String']['output'];
  /** This value is based on organization pricingMode. If pricingMode is 'unit', this value is the quantity of the product. If pricingMode is 'unitMeasure', this value is the measure of the product. */
  quantity: Scalars['Float']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  /** This value is based on organization pricingMode. If pricingMode is 'unit', this value is the unit price of the product. If pricingMode is 'unitMeasure', this value is the measure price of the product. */
  unitPrice: Scalars['Float']['output'];
};

export type OrderClientInput = {
  governmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OrderLotInput = {
  commercialId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products: Array<OrderProductInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type OrderProductInput = {
  agencyId: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  productCodeId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  /** This value is based on organization pricingMode. If pricingMode is 'unit', this value is the quantity of the product. If pricingMode is 'unitMeasure', this value is the measure of the product. */
  quantity: Scalars['Float']['input'];
  /** This value is based on organization pricingMode. If pricingMode is 'unit', this value is the unit price of the product. If pricingMode is 'unitMeasure', this value is the measure price of the product. */
  unitPrice: Scalars['Float']['input'];
};

export type OrgAnalyticsCompaniesSummary = {
  __typename?: 'OrgAnalyticsCompaniesSummary';
  company: CompanyAnalytics;
  totals: OrgAnalyticsCompaniesSummaryStats;
};

export type OrgAnalyticsCompaniesSummaryStats = {
  __typename?: 'OrgAnalyticsCompaniesSummaryStats';
  lots: Scalars['Int']['output'];
  size: Scalars['Float']['output'];
};

export type OrgAnalyticsHarvestSummary = {
  __typename?: 'OrgAnalyticsHarvestSummary';
  /** In Kg */
  declaredProduction: Scalars['Float']['output'];
  /** In Kg */
  deliveredProduction: Scalars['Float']['output'];
  /** In Kg */
  estimatedProduction: Scalars['Float']['output'];
  lots: OrgAnalyticsHarvestSummaryStats;
  size: OrgAnalyticsHarvestSummaryStats;
};

export type OrgAnalyticsHarvestSummaryStats = {
  __typename?: 'OrgAnalyticsHarvestSummaryStats';
  harvested: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  unharvested: Scalars['Float']['output'];
};

export type OrgAnalyticsLot = {
  __typename?: 'OrgAnalyticsLot';
  /** In ha */
  abandonedSize?: Maybe<Scalars['Float']['output']>;
  area?: Maybe<PolygonType>;
  commercialName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  crop: Crop;
  deliveryCondition: DeliveryCondition;
  deliveryMill?: Maybe<Mill>;
  id: Scalars['Int']['output'];
  irrigationWorker?: Maybe<IrrigationWorker>;
  location?: Maybe<PointType>;
  name: Scalars['String']['output'];
  productionType: ProductionType;
  riceLot: OrgAnalyticsRiceLot;
  rtk?: Maybe<MultiLineStringType>;
  seasonField?: Maybe<SeasonField>;
  /** In ha */
  size: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<Variety>;
};

export type OrgAnalyticsLotItem = {
  __typename?: 'OrgAnalyticsLotItem';
  lot: OrgAnalyticsLot;
  status: OrgAnalyticsLotStatus;
};

export type OrgAnalyticsLotStatus = {
  __typename?: 'OrgAnalyticsLotStatus';
  conversions?: Maybe<Array<OrgAnalyticsStatus>>;
  current: OrgAnalyticsStatus;
  estimated?: Maybe<OrgAnalyticsStatus>;
};

export type OrgAnalyticsRiceLot = {
  __typename?: 'OrgAnalyticsRiceLot';
  burningDate?: Maybe<Scalars['String']['output']>;
  burningUpdateType?: Maybe<MilestoneUpdateType>;
  comment?: Maybe<Scalars['String']['output']>;
  daysSinceEmergence?: Maybe<Scalars['Int']['output']>;
  differentiationDate?: Maybe<Scalars['String']['output']>;
  differentiationUpdateType?: Maybe<MilestoneUpdateType>;
  earAppearanceDate?: Maybe<Scalars['String']['output']>;
  earAppearanceUpdateType?: Maybe<MilestoneUpdateType>;
  emergenceDate?: Maybe<Scalars['String']['output']>;
  emergenceUpdateType?: Maybe<MilestoneUpdateType>;
  /** In Kg */
  estimatedYield?: Maybe<Scalars['Float']['output']>;
  firstIrrigationEndDate?: Maybe<Scalars['String']['output']>;
  firstIrrigationStartDate?: Maybe<Scalars['String']['output']>;
  floweringDate?: Maybe<Scalars['String']['output']>;
  floweringUpdateType?: Maybe<MilestoneUpdateType>;
  harvestDate?: Maybe<Scalars['String']['output']>;
  harvestUpdateType?: Maybe<MilestoneUpdateType>;
  historicalIrrigation?: Maybe<HistoricalIrrigation>;
  id: Scalars['Int']['output'];
  isHarvested: Scalars['Boolean']['output'];
  isPlanetEnabled: Scalars['Boolean']['output'];
  physiologicalMaturityDate?: Maybe<Scalars['String']['output']>;
  plantingDate?: Maybe<Scalars['String']['output']>;
  plantingUpdateType?: Maybe<MilestoneUpdateType>;
  preEarAppearanceDate?: Maybe<Scalars['String']['output']>;
  preEarAppearanceUpdateType?: Maybe<MilestoneUpdateType>;
  preparationDate?: Maybe<Scalars['String']['output']>;
  preparationUpdateType?: Maybe<MilestoneUpdateType>;
  /** In Kg */
  yield?: Maybe<Scalars['Float']['output']>;
};

export type OrgAnalyticsStatus = {
  __typename?: 'OrgAnalyticsStatus';
  date: Scalars['String']['output'];
  status: RiceLotStatus;
  updateType: MilestoneUpdateType;
};

export type OrgAnalyticsSummary = {
  __typename?: 'OrgAnalyticsSummary';
  lots: OrgAnalyticsSummaryStats;
  size: OrgAnalyticsSummaryStats;
  totalCommercialExecutives: Scalars['Int']['output'];
  totalCompanies: Scalars['Int']['output'];
};

export type OrgAnalyticsSummaryStats = {
  __typename?: 'OrgAnalyticsSummaryStats';
  filtered: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  allZonesImage?: Maybe<Scalars['String']['output']>;
  country: CountryType;
  crops?: Maybe<Array<OrganizationCropsWithVarieties>>;
  emails?: Maybe<OrganizationEmails>;
  featureFlags: OrganizationFeatureFlags;
  featureSetId?: Maybe<FeatureSet>;
  id: Scalars['Int']['output'];
  invitations?: Maybe<Array<OrganizationInvitation>>;
  isCommercialNameEnabled: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  logoIcon?: Maybe<Scalars['String']['output']>;
  mills?: Maybe<Array<Mill>>;
  name: Scalars['String']['output'];
  pricingMode: PricingMode;
  retailerId?: Maybe<Scalars['Int']['output']>;
  showBrands: Scalars['Boolean']['output'];
  statusMilestones: Array<RiceLotStatus>;
  timelineMilestones: Array<RiceLotStatus>;
  usersRoles?: Maybe<Array<UserOrgRole>>;
};


export type OrganizationCropsArgs = {
  commercialExecutiveId?: InputMaybe<Scalars['Int']['input']>;
  regionId?: InputMaybe<Scalars['Int']['input']>;
  seasonEndRange?: InputMaybe<Scalars['DateTime']['input']>;
  seasonStartRange?: InputMaybe<Scalars['DateTime']['input']>;
  subregionId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationAnalytics = {
  __typename?: 'OrganizationAnalytics';
  companiesSummary?: Maybe<Array<OrgAnalyticsCompaniesSummary>>;
  harvestSummary?: Maybe<OrgAnalyticsHarvestSummary>;
  lots: Array<OrgAnalyticsLotItem>;
  summary?: Maybe<OrgAnalyticsSummary>;
};

export type OrganizationCrmFeature = {
  __typename?: 'OrganizationCrmFeature';
  enabled: Scalars['Boolean']['output'];
  flags: Array<OrganizationCrmModuleFlag>;
};

export enum OrganizationCrmModuleFlag {
  AUTOMATED_MILESTONES = 'AUTOMATED_MILESTONES',
  CLIENTS = 'CLIENTS',
  COMMERCIAL_AGENDA = 'COMMERCIAL_AGENDA',
  COMMERCIAL_ENTITY = 'COMMERCIAL_ENTITY',
  SALES = 'SALES',
  SHOW_COST = 'SHOW_COST',
  STOCK = 'STOCK'
}

export type OrganizationCropsWithVarieties = {
  __typename?: 'OrganizationCropsWithVarieties';
  id: Scalars['Int']['output'];
  locales: LocalesType;
  name: Scalars['String']['output'];
  varieties?: Maybe<OrganizationVarieties>;
};

export type OrganizationCurrentAnalyticsCommercialExecutivesStats = {
  __typename?: 'OrganizationCurrentAnalyticsCommercialExecutivesStats';
  commercialExecutive?: Maybe<User>;
  totals: OrganizationCurrentAnalyticsTotalsStats;
};

export type OrganizationCurrentAnalyticsCompaniesStats = {
  __typename?: 'OrganizationCurrentAnalyticsCompaniesStats';
  company: CompanyAnalytics;
  lotsStats: OrganizationCurrentAnalyticsCompanyLotsStats;
  totals: OrganizationCurrentAnalyticsTotalsStats;
};

export type OrganizationCurrentAnalyticsCompanyLotsStats = {
  __typename?: 'OrganizationCurrentAnalyticsCompanyLotsStats';
  harvestDate: OrganizationCurrentAnalyticsTotalsStats;
};

export type OrganizationCurrentAnalyticsLotProgressStats = {
  __typename?: 'OrganizationCurrentAnalyticsLotProgressStats';
  emergenceDate: OrganizationCurrentAnalyticsTotalsStats;
  harvestDate: OrganizationCurrentAnalyticsTotalsStats;
  plantingDate: OrganizationCurrentAnalyticsTotalsStats;
};

export type OrganizationCurrentAnalyticsSummary = {
  __typename?: 'OrganizationCurrentAnalyticsSummary';
  commercialExecutives: Array<OrganizationCurrentAnalyticsCommercialExecutivesStats>;
  companies: Array<OrganizationCurrentAnalyticsCompaniesStats>;
  lotProgress: OrganizationCurrentAnalyticsLotProgressStats;
  /** @deprecated Use the new field "lotProgress" to get emergence progress data */
  totalLotsWithEmergenceDate: Scalars['Int']['output'];
  /** @deprecated Use the new field "lotProgress" to get emergence progress data */
  totalSizeWithEmergenceDate: Scalars['Float']['output'];
  totals: OrganizationCurrentAnalyticsTotalsStats;
  varieties: Array<OrganizationCurrentAnalyticsVarietiesStats>;
};

export type OrganizationCurrentAnalyticsTotalsStats = {
  __typename?: 'OrganizationCurrentAnalyticsTotalsStats';
  lots: Scalars['Int']['output'];
  size: Scalars['Float']['output'];
};

export type OrganizationCurrentAnalyticsVarietiesStats = {
  __typename?: 'OrganizationCurrentAnalyticsVarietiesStats';
  totals: OrganizationCurrentAnalyticsTotalsStats;
  variety?: Maybe<Variety>;
};

export type OrganizationEmails = {
  __typename?: 'OrganizationEmails';
  orders?: Maybe<Emails>;
};

export type OrganizationFeatureFlags = {
  __typename?: 'OrganizationFeatureFlags';
  crm: OrganizationCrmFeature;
  general: OrganizationGeneralFeature;
  subFarmersManagement: OrganizationSubFarmersFeature;
  supply: OrganizationSupplyFeature;
};

export type OrganizationGeneralFeature = {
  __typename?: 'OrganizationGeneralFeature';
  enabled: Scalars['Boolean']['output'];
  flags: Array<OrganizationGeneralModuleFlag>;
};

export enum OrganizationGeneralModuleFlag {
  FIELD_ENTITY = 'FIELD_ENTITY',
  SATELLITE_IMAGERY = 'SATELLITE_IMAGERY'
}

export type OrganizationInvitation = {
  __typename?: 'OrganizationInvitation';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  regionId?: Maybe<Scalars['Int']['output']>;
  role: UserOrganizationRole;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationMutationResponse = MutationResponseInterface & {
  __typename?: 'OrganizationMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  organization: Organization;
  success: Scalars['Boolean']['output'];
};

export type OrganizationOrder = {
  __typename?: 'OrganizationOrder';
  client: OrganizationOrderClient;
  contribution?: Maybe<Scalars['Float']['output']>;
  contributionPercentage?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['String']['output'];
  deliveryType: DeliveryType;
  id: Scalars['Int']['output'];
  lots: Array<OrganizationOrderLot>;
  notes?: Maybe<Scalars['String']['output']>;
  pickupAgency?: Maybe<Scalars['String']['output']>;
  seller: OrganizationOrderSeller;
  summary: OrganizationOrderSummary;
  total: Scalars['Float']['output'];
};

export type OrganizationOrderClient = {
  __typename?: 'OrganizationOrderClient';
  governmentId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Use "phoneNumbers" field instead */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type OrganizationOrderLot = {
  __typename?: 'OrganizationOrderLot';
  commercialId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  products: Array<OrganizationOrderProduct>;
  size?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type OrganizationOrderMutationResponse = MutationResponseInterface & {
  __typename?: 'OrganizationOrderMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  organizationOrder: OrganizationOrder;
  success: Scalars['Boolean']['output'];
};

export type OrganizationOrderProduct = {
  __typename?: 'OrganizationOrderProduct';
  /** @deprecated Use "brandV2" field instead */
  brand: Scalars['String']['output'];
  brandV2?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  line?: Maybe<CommercialLine>;
  name: Scalars['String']['output'];
  productCodes: Array<OrganizationProductCode>;
  reference?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use "unitV2" field instead */
  unit?: Maybe<StockProductUnit>;
  unitMeasure?: Maybe<Scalars['Float']['output']>;
  /** This value is based on organization pricingMode. If pricingMode is 'unit', this value is the unit price of the product. If pricingMode is 'unitMeasure', this value is the measure price of the product. */
  unitPrice: Scalars['Float']['output'];
  unitV2: StockProductUnit;
};

export type OrganizationOrderSeller = {
  __typename?: 'OrganizationOrderSeller';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationOrderSummary = {
  __typename?: 'OrganizationOrderSummary';
  lots: Array<OrganizationOrderSummaryLots>;
  /** @deprecated Use 'lots' field to get id and name of every lot */
  lotsIds: Array<Scalars['String']['output']>;
  products: Array<OrderAgencyProductSummary>;
  total: Scalars['Float']['output'];
};

export type OrganizationOrderSummaryLots = {
  __typename?: 'OrganizationOrderSummaryLots';
  commercialId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OrganizationOrders = {
  __typename?: 'OrganizationOrders';
  orders: Array<OrganizationOrder>;
};

export type OrganizationProduct = {
  __typename?: 'OrganizationProduct';
  /** @deprecated Use "brandV2" field instead */
  brand: Scalars['String']['output'];
  brandV2?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  inventoryDays?: Maybe<Scalars['Int']['output']>;
  line?: Maybe<CommercialLine>;
  name: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  stockStats?: Maybe<StockStats>;
  /** @deprecated Use "unitV2" field instead */
  unit?: Maybe<StockProductUnit>;
  unitMeasure?: Maybe<Scalars['Float']['output']>;
  unitV2: StockProductUnit;
};

export type OrganizationProductCode = {
  __typename?: 'OrganizationProductCode';
  acquisitionType?: Maybe<AcquisitionType>;
  agencyId: Scalars['Int']['output'];
  agencyName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  /** This value is based on organization pricingMode. If pricingMode is 'unit', this value is the cost of the product. If pricingMode is 'unitMeasure', this value is the measure cost of the product. */
  cost?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isExpired: Scalars['Boolean']['output'];
  /** This value is based on organization pricingMode. If pricingMode is 'unit', this value is the quantity of the product. If pricingMode is 'unitMeasure', this value is the measure of the product. */
  quantity: Scalars['Float']['output'];
};

export type OrganizationProducts = {
  __typename?: 'OrganizationProducts';
  products: Array<OrganizationProduct>;
  stockUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationRole = {
  __typename?: 'OrganizationRole';
  goals?: Maybe<Array<OrganizationUserGoal>>;
  organization: Organization;
  regionId: Scalars['Int']['output'];
  role: UserOrganizationRole;
};

export type OrganizationStats = {
  __typename?: 'OrganizationStats';
  fortnights: Array<Fortnights>;
  statsByProduction: Array<StatsByProductionType>;
  totals: Stats;
};

export type OrganizationSubFarmersFeature = {
  __typename?: 'OrganizationSubFarmersFeature';
  enabled: Scalars['Boolean']['output'];
};

export type OrganizationSupplyFeature = {
  __typename?: 'OrganizationSupplyFeature';
  enabled: Scalars['Boolean']['output'];
  flags: Array<OrganizationSupplyModuleFlag>;
};

export enum OrganizationSupplyModuleFlag {
  CLIENTS = 'CLIENTS',
  SALES = 'SALES',
  STOCK = 'STOCK'
}

export type OrganizationUserGoal = {
  __typename?: 'OrganizationUserGoal';
  contributionGoal?: Maybe<Scalars['Float']['output']>;
  goal?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  /** e.g. 2024-06 */
  yearMonth: Scalars['String']['output'];
};

export type OrganizationVarieties = {
  __typename?: 'OrganizationVarieties';
  results?: Maybe<Array<Variety>>;
  withNoVarietyOption: Scalars['Boolean']['output'];
};

export type OtherStockStates = {
  __typename?: 'OtherStockStates';
  byAgency?: Maybe<Array<AgencyStockState>>;
  measure?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type PageInterface = {
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  resultsTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PointInput = {
  /** Coordinates is a tuple with the following format: [lng, lat] */
  coordinates: Array<Scalars['Float']['input']>;
  type?: Scalars['String']['input'];
};

export type PointType = {
  __typename?: 'PointType';
  /** Coordinates is a tuple with the following format: [lng, lat] */
  coordinates: Array<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type PolygonInput = {
  coordinates: Array<Array<Array<Scalars['Float']['input']>>>;
  type: Scalars['String']['input'];
};

export type PolygonType = {
  __typename?: 'PolygonType';
  coordinates: Array<Array<Array<Scalars['Float']['output']>>>;
  type: Scalars['String']['output'];
};

export type PriceHistoryData = {
  __typename?: 'PriceHistoryData';
  acquisitionType: AcquisitionType;
  amount: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
};

export type PriceStatistics = {
  __typename?: 'PriceStatistics';
  costByAcquisitionType?: Maybe<CostByAcquisitionType>;
  /** @deprecated Use "costbyAcquisitionType" field to get cost */
  currentCost?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use 'costbyAcquisitionType' field to get cost date */
  currentCostDate?: Maybe<Scalars['String']['output']>;
  meanContributionPercentage?: Maybe<Scalars['Float']['output']>;
  meanCost?: Maybe<Scalars['Float']['output']>;
  meanPrice: Scalars['Float']['output'];
};

export enum PricingMode {
  UNIT = 'UNIT',
  UNIT_MEASURE = 'UNIT_MEASURE'
}

export type ProductAgencies = {
  __typename?: 'ProductAgencies';
  agencies: Array<ProductAgency>;
};

export type ProductAgency = {
  __typename?: 'ProductAgency';
  /** @deprecated Use "codesV2" field instead */
  codes?: Maybe<Array<ProductCodeData>>;
  codesV2?: Maybe<Array<ProductCodeData>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ProductCodeData = {
  __typename?: 'ProductCodeData';
  acquisitionType?: Maybe<AcquisitionType>;
  code: Scalars['String']['output'];
  /** This value is based on organization pricingMode. If pricingMode is "unit", this value is the cost of the product. If pricingMode is "unitMeasure", this value is the measure cost of the product. */
  cost?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['Int']['output']>;
  inTransit?: Maybe<Array<InTransitStock>>;
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  /** This value is based on organization pricingMode. If pricingMode is "unit", this value is the suggested price of the product. If pricingMode is "unitMeasure", this value is the measure suggested price of the product. */
  suggestedPrice?: Maybe<Scalars['Float']['output']>;
  totalMeasure?: Maybe<Scalars['Float']['output']>;
  /** This value is based on organization pricingMode. If pricingMode is "unit", this value is the wholesale suggested price of the product. If pricingMode is "unitMeasure", this value is the measure wholesale suggested price of the product. */
  wholesaleSuggestedPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProductPriceHistory = {
  __typename?: 'ProductPriceHistory';
  history?: Maybe<Array<DatePriceHistory>>;
  statistics?: Maybe<PriceStatistics>;
};

export type ProductSale = {
  __typename?: 'ProductSale';
  acquisitionType: AcquisitionType;
  client: SaleClient;
  code: Scalars['String']['output'];
  commercialExecutiveName?: Maybe<Scalars['String']['output']>;
  contribution?: Maybe<Scalars['Float']['output']>;
  contributionPercentage?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  date: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  hasCreditNote: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lot?: Maybe<SaleLot>;
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  reference: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  totalContributions?: Maybe<Scalars['Float']['output']>;
  totalMeasure?: Maybe<Scalars['Float']['output']>;
};

export type ProductSalesStatistics = {
  __typename?: 'ProductSalesStatistics';
  contributionPercentage?: Maybe<Scalars['Float']['output']>;
  lastSaleDate?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  totalContributions?: Maybe<Scalars['Float']['output']>;
  totalMeasure?: Maybe<Scalars['Float']['output']>;
  totalQuantity: Scalars['Float']['output'];
};

export type ProductStockHistory = {
  __typename?: 'ProductStockHistory';
  history: Array<StockHistory>;
  rotation: StockRotation;
};

export type ProductWithSales = {
  __typename?: 'ProductWithSales';
  /** @deprecated Use "brandV2" field instead */
  brandName: Scalars['String']['output'];
  brandV2?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** @deprecated Use "measureUnitV2" field instead */
  measureUnit?: Maybe<StockProductUnit>;
  measureUnitV2: StockProductUnit;
  name: Scalars['String']['output'];
  productIds: Array<Scalars['Int']['output']>;
  sales: Array<ProductSale>;
  statistics: ProductSalesStatistics;
};

export enum ProductionType {
  CONVENTIONAL = 'CONVENTIONAL',
  ORGANIC = 'ORGANIC'
}

export type ProductsSales = {
  __typename?: 'ProductsSales';
  products: Array<ProductWithSales>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Query = {
  __typename?: 'Query';
  clientsSales: ClientsSales;
  commercialAgenda: Array<CommercialEventV2>;
  commercialAgendaV3: Array<CommercialEventV3>;
  commercialEvent: CommercialEventV2;
  commercialEventV3: CommercialEventV3;
  commercialExecutives: Users;
  commercialProducts: CommercialProducts;
  companies: CompaniesPage;
  company: Company;
  countries: Countries;
  crops: Crops;
  dam: Dam;
  dams: Dams;
  field: Field;
  fieldDamsCalendar: FieldDamsCalendar;
  fields: Fields;
  harvestByProducerExport: UrlType;
  historicalSales: HistoricalSales;
  historicalSeasons: Array<HistoricalSeasons>;
  lot: LotV2;
  lotHistoricData: UrlType;
  lots: Lots;
  lotsV2: LotsV2;
  organization: Organization;
  organizationAnalytics: OrganizationAnalytics;
  organizationAnalyticsExport: UrlType;
  organizationCompanies: Companies;
  organizationCurrentAnalyticsSummary: OrganizationCurrentAnalyticsSummary;
  organizationOrders: OrganizationOrders;
  organizationProduct: OrganizationProduct;
  organizationProducts: OrganizationProducts;
  organizationStats: OrganizationStats;
  productAgencies: ProductAgencies;
  productPriceHistory?: Maybe<ProductPriceHistory>;
  productStockHistory?: Maybe<ProductStockHistory>;
  productsSales: ProductsSales;
  recommendations: Recommendations;
  regionCrop: RegionCrop;
  regions: Regions;
  retailerClients: RetailerClients;
  retailerRegionsAgencies: Array<RegionAgencies>;
  riceActiveIngredients: RiceActiveIngredients;
  riceNutrients: RiceNutrients;
  riceUnits: RiceUnits;
  sales: Sales;
  salesRepClients: SalesRepClients;
  salesSummary: SalesSummary;
  season: Season;
  seasonFieldCalendar: SeasonFieldCalendar;
  seasonLots: SeasonLots;
  seasonLotsExport: UrlType;
  seasons: Seasons;
  stockBrands: Array<StockBrand>;
  subregions: Subregions;
  unassignedClients: UnassignedClients;
  user: User;
  users: UsersPage;
  varieties: Varieties;
  versions: Versions;
};


export type QueryClientsSalesArgs = {
  agenciesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandNames?: InputMaybe<Array<Scalars['String']['input']>>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  commercialExecutiveId?: InputMaybe<Scalars['Int']['input']>;
  dateRange?: InputMaybe<NullableEndDateRangeInput>;
  productLines?: InputMaybe<Array<CommercialLine>>;
  yearMonthRange?: InputMaybe<YearMonthRange>;
};


export type QueryCommercialAgendaArgs = {
  status?: InputMaybe<Status>;
};


export type QueryCommercialAgendaV3Args = {
  status?: InputMaybe<Status>;
};


export type QueryCommercialEventArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCommercialEventV3Args = {
  id: Scalars['Int']['input'];
};


export type QueryCommercialExecutivesArgs = {
  regionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompaniesArgs = {
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCropsArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDamArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDamsArgs = {
  fieldId: Scalars['Int']['input'];
};


export type QueryFieldArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFieldDamsCalendarArgs = {
  fieldId: Scalars['Int']['input'];
  fromYearMonth?: InputMaybe<Scalars['String']['input']>;
  toYearMonth?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFieldsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryHarvestByProducerExportArgs = {
  commercialExecutiveId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  cropId: Scalars['Int']['input'];
  regionId?: InputMaybe<Scalars['Int']['input']>;
  seasonEndRange?: InputMaybe<Scalars['DateTime']['input']>;
  seasonStartRange?: InputMaybe<Scalars['DateTime']['input']>;
  subregionId?: InputMaybe<Scalars['Int']['input']>;
  varietyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLotArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLotHistoricDataArgs = {
  area: PolygonInput;
  companyName: Scalars['String']['input'];
  emergenceDate: Scalars['DateTime']['input'];
  fieldName: Scalars['String']['input'];
  fromTime: Scalars['DateTime']['input'];
  lotName: Scalars['String']['input'];
  toTime: Scalars['DateTime']['input'];
  varietyName: Scalars['String']['input'];
  yield: Scalars['String']['input'];
  yieldUnit: Scalars['String']['input'];
};


export type QueryLotsArgs = {
  fieldId: Scalars['Int']['input'];
  seasonId: Scalars['Int']['input'];
};


export type QueryLotsV2Args = {
  discardWithoutArea?: InputMaybe<Scalars['Boolean']['input']>;
  fieldId: Scalars['Int']['input'];
  seasonId: Scalars['Int']['input'];
};


export type QueryOrganizationAnalyticsArgs = {
  commercialExecutiveId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  cropId: Scalars['Int']['input'];
  dateRange?: InputMaybe<DateRangeInput>;
  deliveryCondition?: InputMaybe<DeliveryCondition>;
  grainType?: InputMaybe<GrainType>;
  productionType?: InputMaybe<ProductionType>;
  regionId?: InputMaybe<Scalars['Int']['input']>;
  seasonEndRange?: InputMaybe<Scalars['DateTime']['input']>;
  seasonStartRange?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<RiceLotStatus>>;
  subregionId?: InputMaybe<Scalars['Int']['input']>;
  timeMode?: InputMaybe<AnalyticsTimeMode>;
  varietyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationAnalyticsExportArgs = {
  commercialExecutiveId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  cropId: Scalars['Int']['input'];
  dateRange?: InputMaybe<DateRangeInput>;
  regionId?: InputMaybe<Scalars['Int']['input']>;
  seasonEndRange?: InputMaybe<Scalars['DateTime']['input']>;
  seasonStartRange?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<RiceLotStatus>>;
  subregionId?: InputMaybe<Scalars['Int']['input']>;
  timeMode?: InputMaybe<AnalyticsTimeMode>;
  varietyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationCompaniesArgs = {
  regionId?: InputMaybe<Scalars['Int']['input']>;
  seasonRange?: InputMaybe<NullableEndDateRangeInput>;
};


export type QueryOrganizationCurrentAnalyticsSummaryArgs = {
  commercialExecutiveId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  cropId: Scalars['Int']['input'];
  regionId?: InputMaybe<Scalars['Int']['input']>;
  seasonEndRange?: InputMaybe<Scalars['DateTime']['input']>;
  seasonStartRange?: InputMaybe<Scalars['DateTime']['input']>;
  subregionId?: InputMaybe<Scalars['Int']['input']>;
  varietyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationOrdersArgs = {
  dateRange?: InputMaybe<NullableEndDateRangeInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationProductArgs = {
  agenciesIds: Array<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


export type QueryOrganizationProductsArgs = {
  agenciesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationStatsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  cropId: Scalars['Int']['input'];
  deliveryCondition?: InputMaybe<DeliveryCondition>;
  grainType?: InputMaybe<GrainType>;
  productionType?: InputMaybe<ProductionType>;
  regionId?: InputMaybe<Scalars['Int']['input']>;
  seasonEndRange?: InputMaybe<Scalars['DateTime']['input']>;
  seasonStartRange?: InputMaybe<Scalars['DateTime']['input']>;
  status: RiceLotStatus;
  subregionId?: InputMaybe<Scalars['Int']['input']>;
  varietyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductAgenciesArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryProductPriceHistoryArgs = {
  agencyId: Scalars['Int']['input'];
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductStockHistoryArgs = {
  agencyId: Scalars['Int']['input'];
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderByDate?: InputMaybe<Order>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductsSalesArgs = {
  agenciesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  commercialExecutiveId?: InputMaybe<Scalars['Int']['input']>;
  dateRange?: InputMaybe<NullableEndDateRangeInput>;
  mode?: InputMaybe<SalesMode>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  productLines?: InputMaybe<Array<CommercialLine>>;
  productName?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  salesLimit?: InputMaybe<Scalars['Float']['input']>;
  yearMonthRange?: InputMaybe<YearMonthRange>;
};


export type QueryRegionCropArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRetailerClientsArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRiceActiveIngredientsArgs = {
  countryId: CountryId;
};


export type QueryRiceNutrientsArgs = {
  countryId: CountryId;
};


export type QueryRiceUnitsArgs = {
  countryId: CountryId;
};


export type QuerySalesArgs = {
  agenciesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  commercialExecutiveId?: InputMaybe<Scalars['Int']['input']>;
  dateRange?: InputMaybe<NullableEndDateRangeInput>;
  productLines?: InputMaybe<Array<CommercialLine>>;
  yearMonth?: InputMaybe<Scalars['String']['input']>;
  yearMonthRange?: InputMaybe<YearMonthRange>;
};


export type QuerySalesSummaryArgs = {
  agenciesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  commercialExecutiveId?: InputMaybe<Scalars['Int']['input']>;
  productLines?: InputMaybe<Array<CommercialLine>>;
  yearMonthRange: YearMonthRange;
};


export type QuerySeasonArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySeasonFieldCalendarArgs = {
  fieldId: Scalars['Int']['input'];
  fromYearMonth?: InputMaybe<Scalars['String']['input']>;
  seasonId: Scalars['Int']['input'];
  toYearMonth?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySeasonLotsArgs = {
  endRange: Scalars['DateTime']['input'];
  startRange: Scalars['DateTime']['input'];
};


export type QuerySeasonLotsExportArgs = {
  endRange: Scalars['DateTime']['input'];
  lotsIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startRange: Scalars['DateTime']['input'];
};


export type QuerySeasonsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QuerySubregionsArgs = {
  regionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};


export type QueryVarietiesArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  countryId: CountryId;
  cropId: Scalars['Int']['input'];
};

export type RangeSummary = {
  __typename?: 'RangeSummary';
  contributionPercentage?: Maybe<Scalars['Float']['output']>;
  contributions: SummaryStatistics;
  measure: SummaryStatistics;
  rangeName: Scalars['String']['output'];
  sales: SummaryStatistics;
};

export type RealYieldCurve = {
  __typename?: 'RealYieldCurve';
  values: Array<CurveValue>;
};

export type Recommendation = {
  __typename?: 'Recommendation';
  company: RecommendationCompany;
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lotName: Scalars['String']['output'];
  /** In ha */
  lotSize: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  products: Array<RecommendationProduct>;
};

export type RecommendationBrand = {
  __typename?: 'RecommendationBrand';
  /** @deprecated Use the new field "name" to get brand name identification */
  externalId?: Maybe<Scalars['String']['output']>;
  logoIcon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  salesRepFullName: Scalars['String']['output'];
};

export type RecommendationClientInput = {
  governmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RecommendationCompany = {
  __typename?: 'RecommendationCompany';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RecommendationInfo = {
  __typename?: 'RecommendationInfo';
  brandInfo: RecommendationBrand;
  id: Scalars['Int']['output'];
  isNewClient: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  products: Array<RecommendationProductInfo>;
};

export type RecommendationMutationResponse = MutationResponseInterface & {
  __typename?: 'RecommendationMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  recommendation: Recommendation;
  success: Scalars['Boolean']['output'];
};

export type RecommendationProduct = {
  __typename?: 'RecommendationProduct';
  id: Scalars['Int']['output'];
  line?: Maybe<CommercialLine>;
  name: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  unit: CommercialUnit;
};

export type RecommendationProductInfo = {
  __typename?: 'RecommendationProductInfo';
  id: Scalars['Int']['output'];
  line?: Maybe<CommercialLine>;
  name: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
  unit: CommercialUnit;
};

export type RecommendationProductInput = {
  id: Scalars['Int']['input'];
  quantity: Scalars['Float']['input'];
};

export type Recommendations = {
  __typename?: 'Recommendations';
  results: Array<Recommendation>;
};

export type Region = {
  __typename?: 'Region';
  id: Scalars['Int']['output'];
  location: PointType;
  mapPictureId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['Int']['output'];
};

export type RegionAgencies = {
  __typename?: 'RegionAgencies';
  agencies: Array<Agency>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RegionCrop = {
  __typename?: 'RegionCrop';
  cropId: Scalars['Int']['output'];
  cycleStageDays: CycleStageDays;
  id: Scalars['Int']['output'];
  regionId: Scalars['Int']['output'];
};

export type RegionCropMutationResponse = MutationResponseInterface & {
  __typename?: 'RegionCropMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  regionCrop: RegionCrop;
  success: Scalars['Boolean']['output'];
};

export type Regions = {
  __typename?: 'Regions';
  results: Array<Region>;
};

export type ReservedStock = {
  __typename?: 'ReservedStock';
  destinationAgency?: Maybe<Scalars['String']['output']>;
  measure?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  type: ReservedStockType;
};

export type ReservedStockData = {
  __typename?: 'ReservedStockData';
  stock: Array<ReservedStock>;
  totalMeasure?: Maybe<Scalars['Float']['output']>;
  totalQuantity: Scalars['Int']['output'];
};

export enum ReservedStockType {
  SALE = 'SALE',
  TRANSIT = 'TRANSIT'
}

export type ReservedTransitStock = {
  __typename?: 'ReservedTransitStock';
  agency: Scalars['String']['output'];
  measure?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type RetailerClient = {
  __typename?: 'RetailerClient';
  governmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lots?: Maybe<Array<ClientLot>>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
};

export type RetailerClients = {
  __typename?: 'RetailerClients';
  clients: Array<RetailerClient>;
};

export type RiceActiveIngredient = {
  __typename?: 'RiceActiveIngredient';
  id: Scalars['Int']['output'];
  locales: LocalesType;
  name: Scalars['String']['output'];
};

export type RiceActiveIngredients = {
  __typename?: 'RiceActiveIngredients';
  results: Array<RiceActiveIngredient>;
};

export type RiceAppliedFertilizer = {
  __typename?: 'RiceAppliedFertilizer';
  brand?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  grades?: Maybe<Array<FertilizerGrade>>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<RiceUnit>;
};

export type RiceAppliedFertilizerMutationResponse = MutationResponseInterface & {
  __typename?: 'RiceAppliedFertilizerMutationResponse';
  code: Scalars['String']['output'];
  fertilizer: RiceAppliedFertilizer;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RiceAppliedPhytosanitary = {
  __typename?: 'RiceAppliedPhytosanitary';
  activeIngredients?: Maybe<Array<RiceActiveIngredient>>;
  brand?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<RiceUnit>;
};

export type RiceAppliedPhytosanitaryMutationResponse = MutationResponseInterface & {
  __typename?: 'RiceAppliedPhytosanitaryMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  phytosanitary: RiceAppliedPhytosanitary;
  success: Scalars['Boolean']['output'];
};

export type RiceLot = {
  __typename?: 'RiceLot';
  appliedFertilizers: Array<RiceAppliedFertilizer>;
  appliedPhytosanitaries: Array<RiceAppliedPhytosanitary>;
  burningDate?: Maybe<Scalars['String']['output']>;
  burningUpdateType?: Maybe<MilestoneUpdateType>;
  calendarV2?: Maybe<Array<CalendarDateV2>>;
  calendarV3?: Maybe<Array<CalendarDateV3>>;
  comment?: Maybe<Scalars['String']['output']>;
  daysSinceEmergence?: Maybe<Scalars['Int']['output']>;
  differentiationDate?: Maybe<Scalars['String']['output']>;
  differentiationUpdateType?: Maybe<MilestoneUpdateType>;
  earAppearanceDate?: Maybe<Scalars['String']['output']>;
  earAppearanceUpdateType?: Maybe<MilestoneUpdateType>;
  emergenceDate?: Maybe<Scalars['String']['output']>;
  emergenceDaysActivationIndices: EmergenceDaysActivationIndices;
  emergenceUpdateType?: Maybe<MilestoneUpdateType>;
  estimatedYield: EstimatedYield;
  firstIrrigationEndDate?: Maybe<Scalars['String']['output']>;
  firstIrrigationStartDate?: Maybe<Scalars['String']['output']>;
  floweringDate?: Maybe<Scalars['String']['output']>;
  floweringUpdateType?: Maybe<MilestoneUpdateType>;
  harvestDate?: Maybe<Scalars['String']['output']>;
  harvestUpdateType?: Maybe<MilestoneUpdateType>;
  historicalIrrigation?: Maybe<HistoricalIrrigation>;
  id: Scalars['Int']['output'];
  indicators?: Maybe<Indicators>;
  isHarvested: Scalars['Boolean']['output'];
  isPlanetEnabled: Scalars['Boolean']['output'];
  physiologicalMaturityDate?: Maybe<Scalars['String']['output']>;
  plantingDate?: Maybe<Scalars['String']['output']>;
  plantingUpdateType?: Maybe<MilestoneUpdateType>;
  preEarAppearanceDate?: Maybe<Scalars['String']['output']>;
  preEarAppearanceUpdateType?: Maybe<MilestoneUpdateType>;
  preparationDate?: Maybe<Scalars['String']['output']>;
  preparationUpdateType?: Maybe<MilestoneUpdateType>;
  realYieldCurve?: Maybe<RealYieldCurve>;
  targetYieldCurve?: Maybe<TargetYieldCurve>;
  /** In Kg */
  yield?: Maybe<Scalars['Float']['output']>;
};


export type RiceLotCalendarV2Args = {
  fromYearMonth?: InputMaybe<Scalars['String']['input']>;
  toYearMonth?: InputMaybe<Scalars['String']['input']>;
};


export type RiceLotCalendarV3Args = {
  fromYearMonth?: InputMaybe<Scalars['String']['input']>;
  toYearMonth?: InputMaybe<Scalars['String']['input']>;
};

export type RiceLotMutationResponse = MutationResponseInterface & {
  __typename?: 'RiceLotMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  riceLot: RiceLot;
  success: Scalars['Boolean']['output'];
};

export type RiceLotStages = {
  __typename?: 'RiceLotStages';
  BURNING?: Maybe<Scalars['Int']['output']>;
  DIFFERENTIATION?: Maybe<Scalars['Int']['output']>;
  EAR_APPEARANCE?: Maybe<Scalars['Int']['output']>;
  EMERGENCE?: Maybe<Scalars['Int']['output']>;
  END_IRRIGATION?: Maybe<Scalars['Int']['output']>;
  FLOWERING?: Maybe<Scalars['Int']['output']>;
  HARVEST?: Maybe<Scalars['Int']['output']>;
  INITIAL_FLOOD?: Maybe<Scalars['Int']['output']>;
  PHYSIOLOGICAL_MATURITY?: Maybe<Scalars['Int']['output']>;
  PLANTING?: Maybe<Scalars['Int']['output']>;
  PREPARATION?: Maybe<Scalars['Int']['output']>;
  PRE_EAR_APPEARANCE?: Maybe<Scalars['Int']['output']>;
  START_IRRIGATION?: Maybe<Scalars['Int']['output']>;
  VEGETATIVE_STATE_THREE?: Maybe<Scalars['Int']['output']>;
};

export type RiceLotStagesInput = {
  BURNING?: InputMaybe<Scalars['Int']['input']>;
  DIFFERENTIATION?: InputMaybe<Scalars['Int']['input']>;
  EAR_APPEARANCE?: InputMaybe<Scalars['Int']['input']>;
  EMERGENCE?: InputMaybe<Scalars['Int']['input']>;
  END_IRRIGATION?: InputMaybe<Scalars['Int']['input']>;
  FLOWERING?: InputMaybe<Scalars['Int']['input']>;
  HARVEST?: InputMaybe<Scalars['Int']['input']>;
  INITIAL_FLOOD?: InputMaybe<Scalars['Int']['input']>;
  PHYSIOLOGICAL_MATURITY?: InputMaybe<Scalars['Int']['input']>;
  PLANTING?: InputMaybe<Scalars['Int']['input']>;
  PREPARATION?: InputMaybe<Scalars['Int']['input']>;
  PRE_EAR_APPEARANCE?: InputMaybe<Scalars['Int']['input']>;
  START_IRRIGATION?: InputMaybe<Scalars['Int']['input']>;
  VEGETATIVE_STATE_THREE?: InputMaybe<Scalars['Int']['input']>;
};

export enum RiceLotStatus {
  BURNING = 'BURNING',
  DIFFERENTIATION = 'DIFFERENTIATION',
  EAR_APPEARANCE = 'EAR_APPEARANCE',
  EMERGENCE = 'EMERGENCE',
  END_IRRIGATION = 'END_IRRIGATION',
  FLOWERING = 'FLOWERING',
  HARVEST = 'HARVEST',
  INITIAL_FLOOD = 'INITIAL_FLOOD',
  PHYSIOLOGICAL_MATURITY = 'PHYSIOLOGICAL_MATURITY',
  PLANTING = 'PLANTING',
  PREPARATION = 'PREPARATION',
  PRE_EAR_APPEARANCE = 'PRE_EAR_APPEARANCE',
  START_IRRIGATION = 'START_IRRIGATION',
  VEGETATIVE_STATE_THREE = 'VEGETATIVE_STATE_THREE'
}

export type RiceNutrient = {
  __typename?: 'RiceNutrient';
  id: Scalars['Int']['output'];
  locales: LocalesType;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type RiceNutrients = {
  __typename?: 'RiceNutrients';
  results: Array<RiceNutrient>;
};

export type RiceUnit = {
  __typename?: 'RiceUnit';
  id: Scalars['Int']['output'];
  locales: LocalesType;
  name: Scalars['String']['output'];
};

export type RiceUnits = {
  __typename?: 'RiceUnits';
  results: Array<RiceUnit>;
};

export type Sale = {
  __typename?: 'Sale';
  client: SaleClient;
  commercialExecutiveName?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  hasCreditNote: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lot?: Maybe<SaleLot>;
  measureUnit: StockProductUnit;
  products: Array<SaleProduct>;
  total: Scalars['Float']['output'];
  totalContributions?: Maybe<Scalars['Float']['output']>;
  /** This value is the sum between "totalWeight" and "totalVolume" */
  totalMeasure: Scalars['Float']['output'];
  totalVolume: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
};

export type SaleClient = {
  __typename?: 'SaleClient';
  name: Scalars['String']['output'];
};

export type SaleLot = {
  __typename?: 'SaleLot';
  commercialName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** In ha */
  size: Scalars['Float']['output'];
};

export type SaleProduct = {
  __typename?: 'SaleProduct';
  /** @deprecated Use "brandV2" field instead */
  brandName: Scalars['String']['output'];
  brandV2?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  contribution?: Maybe<Scalars['Float']['output']>;
  contributionPercentage?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use "measureUnitV2" field instead */
  measureUnit?: Maybe<StockProductUnit>;
  measureUnitV2: StockProductUnit;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  reference: Scalars['String']['output'];
  totalMeasure?: Maybe<Scalars['Float']['output']>;
};

export type Sales = {
  __typename?: 'Sales';
  sales: Array<Sale>;
  statistics?: Maybe<SalesStatisticsByPeriod>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SalesGoal = {
  __typename?: 'SalesGoal';
  goal?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Float']['output'];
};

export enum SalesMode {
  HISTORIC = 'HISTORIC',
  RECENT = 'RECENT'
}

export type SalesRepClient = {
  __typename?: 'SalesRepClient';
  governmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type SalesRepClients = {
  __typename?: 'SalesRepClients';
  clients: Array<SalesRepClient>;
};

export type SalesStatistics = {
  __typename?: 'SalesStatistics';
  contributionsGoal?: Maybe<SalesGoal>;
  /** @deprecated Use "salesGoal" field to get goal */
  goal?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use "salesGoal" field to get percentage */
  percentage?: Maybe<Scalars['Int']['output']>;
  salesGoal: SalesGoal;
  /** @deprecated Use "salesGoal" field to get sales total */
  total: Scalars['Float']['output'];
  totalVolume: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  yearMonth: Scalars['String']['output'];
};

export type SalesStatisticsByPeriod = {
  __typename?: 'SalesStatisticsByPeriod';
  byYearMonth: Array<SalesStatistics>;
  /** @deprecated Use "byYearMonth" field instead */
  monthly: SalesStatistics;
};

export type SalesSummary = {
  __typename?: 'SalesSummary';
  currentRangeSummary?: Maybe<RangeSummary>;
  previousRangeSummary?: Maybe<RangeSummary>;
};

export type Season = {
  __typename?: 'Season';
  commercialExecutive?: Maybe<User>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  /** The season is enabled if start date is within the last twelve months or if the isEnabled flag is true */
  isEnabled: Scalars['Boolean']['output'];
  millDeliveryType?: Maybe<SeasonMillDeliveryType>;
  name: Scalars['String']['output'];
  productionToMill?: Maybe<Scalars['Float']['output']>;
  seasonFields: Array<SeasonField>;
  startDate: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeasonField = {
  __typename?: 'SeasonField';
  field?: Maybe<Field>;
  id: Scalars['Int']['output'];
  lots: Array<LotV2>;
  season?: Maybe<Season>;
};

export type SeasonFieldCalendar = {
  __typename?: 'SeasonFieldCalendar';
  dates: Array<SeasonFieldCalendarDate>;
};

export type SeasonFieldCalendarDate = {
  __typename?: 'SeasonFieldCalendarDate';
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  indices: CalendarIndices;
};

export type SeasonLot = {
  __typename?: 'SeasonLot';
  /** In ha */
  abandonedSize?: Maybe<Scalars['Float']['output']>;
  company: SeasonLotCompany;
  crop: Crop;
  deliveryCondition: DeliveryCondition;
  deliveryMill?: Maybe<Mill>;
  field: SeasonLotField;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  previousCrop?: Maybe<Crop>;
  productionType: ProductionType;
  riceLot: SeasonLotRiceLot;
  season: SeasonLotSeason;
  /** In ha */
  size: Scalars['Float']['output'];
  variety?: Maybe<Variety>;
};

export type SeasonLotCompany = {
  __typename?: 'SeasonLotCompany';
  country: CountryType;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SeasonLotField = {
  __typename?: 'SeasonLotField';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SeasonLotRiceLot = {
  __typename?: 'SeasonLotRiceLot';
  burningDate?: Maybe<Scalars['String']['output']>;
  burningUpdateType?: Maybe<MilestoneUpdateType>;
  daysSinceEmergence?: Maybe<Scalars['Int']['output']>;
  differentiationDate?: Maybe<Scalars['String']['output']>;
  differentiationUpdateType?: Maybe<MilestoneUpdateType>;
  earAppearanceDate?: Maybe<Scalars['String']['output']>;
  earAppearanceUpdateType?: Maybe<MilestoneUpdateType>;
  emergenceDate?: Maybe<Scalars['String']['output']>;
  emergenceUpdateType?: Maybe<MilestoneUpdateType>;
  estimatedYield: EstimatedYield;
  firstIrrigationEndDate?: Maybe<Scalars['String']['output']>;
  firstIrrigationStartDate?: Maybe<Scalars['String']['output']>;
  floweringDate?: Maybe<Scalars['String']['output']>;
  floweringUpdateType?: Maybe<MilestoneUpdateType>;
  harvestDate?: Maybe<Scalars['String']['output']>;
  harvestUpdateType?: Maybe<MilestoneUpdateType>;
  id: Scalars['Int']['output'];
  isHarvested: Scalars['Boolean']['output'];
  physiologicalMaturityDate?: Maybe<Scalars['String']['output']>;
  plantingDate?: Maybe<Scalars['String']['output']>;
  plantingUpdateType?: Maybe<MilestoneUpdateType>;
  preparationDate?: Maybe<Scalars['String']['output']>;
  preparationUpdateType?: Maybe<MilestoneUpdateType>;
  /** In Kg */
  yield?: Maybe<Scalars['Float']['output']>;
};

export type SeasonLotSeason = {
  __typename?: 'SeasonLotSeason';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SeasonLots = {
  __typename?: 'SeasonLots';
  results: Array<SeasonLot>;
};

export enum SeasonMillDeliveryType {
  NO_DELIVERY = 'NO_DELIVERY',
  PARTIAL = 'PARTIAL',
  TOTAL = 'TOTAL'
}

export type SeasonMutationResponse = MutationResponseInterface & {
  __typename?: 'SeasonMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  season: Season;
  success: Scalars['Boolean']['output'];
};

export type Seasons = {
  __typename?: 'Seasons';
  results: Array<Season>;
};

export enum SentinelHubProvider {
  LANDSAT89 = 'LANDSAT89',
  LANDSAT89_PLANET_FUSION = 'LANDSAT89_PLANET_FUSION',
  PLANET = 'PLANET',
  SENTINEL1 = 'SENTINEL1',
  SENTINEL2 = 'SENTINEL2',
  SENTINEL2_PLANET_FUSION = 'SENTINEL2_PLANET_FUSION'
}

export type SignupResponse = MutationResponseInterface & {
  __typename?: 'SignupResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Stats = {
  __typename?: 'Stats';
  /** In ha */
  area: Scalars['Int']['output'];
  /** In ha */
  emergedArea: Scalars['Int']['output'];
  fortnightsStats: FortnightsStats;
  /** In ha */
  harvestedArea: Scalars['Int']['output'];
  /** In ha */
  notEmergedArea: Scalars['Int']['output'];
  /** In Kg */
  notEmergedYield: Scalars['Int']['output'];
  /** In ha */
  plantedArea: Scalars['Int']['output'];
  /** In Kg */
  subTotalYieldByDeliveryCondition: Scalars['Int']['output'];
  /** In Kg */
  yield: Scalars['Int']['output'];
  yieldByDeliveryCondition: Array<DeliveryConditionYield>;
};

export type StatsByGrainType = {
  __typename?: 'StatsByGrainType';
  grainType: GrainType;
  stats: Stats;
};

export type StatsByProductionType = {
  __typename?: 'StatsByProductionType';
  productionType: ProductionType;
  statsByGrainType: Array<StatsByGrainType>;
  totals: Stats;
};

export enum Status {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED'
}

export type StockAmount = {
  __typename?: 'StockAmount';
  measure?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type StockBrand = {
  __typename?: 'StockBrand';
  name: Scalars['String']['output'];
};

export type StockHistory = {
  __typename?: 'StockHistory';
  date: Scalars['String']['output'];
  displayFullDate: Scalars['String']['output'];
  displayShortDate: Scalars['String']['output'];
  stock: Scalars['Int']['output'];
};

export enum StockProductUnit {
  CC = 'CC',
  G = 'G',
  KG = 'KG',
  KG_L = 'KG_L',
  L = 'L',
  ML = 'ML',
  MT = 'MT',
  TON = 'TON',
  UNIT = 'UNIT'
}

export type StockRotation = {
  __typename?: 'StockRotation';
  daily: Scalars['Float']['output'];
  monthly?: Maybe<Scalars['Int']['output']>;
  weekly?: Maybe<Scalars['Int']['output']>;
};

export type StockStats = {
  __typename?: 'StockStats';
  byAcquisitionType?: Maybe<StockStatsByAcquisitionType>;
  expirations?: Maybe<Expirations>;
  measure?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  /** Total cost of the stock */
  totalCost?: Maybe<Scalars['Float']['output']>;
};

export type StockStatsByAcquisitionType = {
  __typename?: 'StockStatsByAcquisitionType';
  consignment?: Maybe<StockStatsByExpiration>;
  purchase?: Maybe<StockStatsByExpiration>;
  unclassified?: Maybe<StockStatsByExpiration>;
};

export type StockStatsByExpiration = {
  __typename?: 'StockStatsByExpiration';
  codes?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use expirationsByAgency instead. Latest mobile supported version is v1.40.0 */
  expirations?: Maybe<Expirations>;
  expirationsByAgency?: Maybe<Array<ExpirationByAgency>>;
  measure?: Maybe<Scalars['Float']['output']>;
  otherStates?: Maybe<OtherStockStates>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type Subregion = {
  __typename?: 'Subregion';
  estimatedYield: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  location: PointType;
  name: Scalars['String']['output'];
  region?: Maybe<Region>;
  regionId: Scalars['Int']['output'];
};

export type Subregions = {
  __typename?: 'Subregions';
  results: Array<Subregion>;
};

export type SummaryStatistics = {
  __typename?: 'SummaryStatistics';
  compliancePercentage?: Maybe<Scalars['Float']['output']>;
  goal?: Maybe<Scalars['Float']['output']>;
  growthPercentage?: Maybe<Scalars['Float']['output']>;
  remaining?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type TargetYieldCurve = {
  __typename?: 'TargetYieldCurve';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  values: Array<CurveValue>;
  varietyId: Scalars['Int']['output'];
  yield?: Maybe<Scalars['Float']['output']>;
};

export enum TimelapseMoment {
  AFTER = 'AFTER',
  BEFORE = 'BEFORE',
  ON_MILESTONE = 'ON_MILESTONE'
}

export enum TimelapseType {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS'
}

export type UnassignedClient = {
  __typename?: 'UnassignedClient';
  brand?: Maybe<Scalars['String']['output']>;
  daysSinceVisit: Scalars['Int']['output'];
  governmentId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnassignedClients = {
  __typename?: 'UnassignedClients';
  clients: Array<UnassignedClient>;
};

export type UpdateCompanyInput = {
  governmentId?: InputMaybe<Scalars['String']['input']>;
  irrigationWorkersAccessMode?: InputMaybe<IrrigationWorkersAccessMode>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  subregionId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDamInput = {
  area?: InputMaybe<PolygonInput>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFieldInput = {
  createDamsDTOs?: InputMaybe<Array<CreateDamDto>>;
  deliveryCondition?: InputMaybe<DeliveryCondition>;
  directions?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<PointInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  productionType?: InputMaybe<ProductionType>;
};

export type UpdateLotInput = {
  /** In ha */
  abandonedSize?: InputMaybe<Scalars['Float']['input']>;
  area?: InputMaybe<PolygonInput>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  cropId?: InputMaybe<Scalars['Int']['input']>;
  deliveryMillId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  irrigationWorkerId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previousCropId?: InputMaybe<Scalars['Int']['input']>;
  rtk?: InputMaybe<MultiLineStringInput>;
  rtkFile?: InputMaybe<Scalars['Upload']['input']>;
  /** In ha */
  size?: InputMaybe<Scalars['Float']['input']>;
  varietyId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrganizationInput = {
  logo?: InputMaybe<Scalars['Upload']['input']>;
  logoIcon?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationUserMutationResponse = MutationResponseInterface & {
  __typename?: 'UpdateOrganizationUserMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  orgUser: UserOrgRole;
  success: Scalars['Boolean']['output'];
};

export type UpdateRegionCropInput = {
  cycleStageDays: CycleStageDaysInput;
};

export type UpdateRiceAppliedFertilizerInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  fertilizerGrades?: InputMaybe<Array<FertilizerGradeInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRiceAppliedPhytosanitaryInput = {
  activeIngredients?: InputMaybe<Array<Scalars['Int']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRiceLotInput = {
  burningDate?: InputMaybe<Scalars['DateTime']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  differentiationDate?: InputMaybe<Scalars['DateTime']['input']>;
  earAppearanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  emergenceDate?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedYield?: InputMaybe<Scalars['Float']['input']>;
  firstIrrigationEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstIrrigationStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  floweringDate?: InputMaybe<Scalars['DateTime']['input']>;
  harvestDate?: InputMaybe<Scalars['DateTime']['input']>;
  physiologicalMaturityDate?: InputMaybe<Scalars['DateTime']['input']>;
  plantingDate?: InputMaybe<Scalars['DateTime']['input']>;
  preparationDate?: InputMaybe<Scalars['DateTime']['input']>;
  yield?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSeasonInput = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  millDeliveryType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productionToMill?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateUnitMeasureMapInput = {
  externalUnits: Array<Scalars['String']['input']>;
  unit: StockProductUnit;
};

export type UpdateUserInput = {
  actualPassword?: InputMaybe<Scalars['String']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['Upload']['input']>;
};

export type UrlType = {
  __typename?: 'UrlType';
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  companiesRoles?: Maybe<Array<CompanyRole>>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isOnboarded: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationRole?: Maybe<OrganizationRole>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  regions?: Maybe<Array<Region>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum UserCompanyRole {
  ADMIN = 'ADMIN',
  IRRIGATION_WORKER = 'IRRIGATION_WORKER',
  VIEWER = 'VIEWER'
}

export type UserMutationResponse = MutationResponseInterface & {
  __typename?: 'UserMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user: User;
};

export type UserOrgRole = {
  __typename?: 'UserOrgRole';
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  regionId?: Maybe<Scalars['Int']['output']>;
  role: UserOrganizationRole;
  user: User;
};

export enum UserOrganizationRole {
  ADMIN = 'ADMIN',
  COMMERCIAL = 'COMMERCIAL',
  MILL = 'MILL',
  SALES_REP = 'SALES_REP'
}

export type UserRole = {
  __typename?: 'UserRole';
  role: UserCompanyRole;
  user: User;
};

export type Users = {
  __typename?: 'Users';
  results: Array<User>;
};

export type UsersPage = PageInterface & {
  __typename?: 'UsersPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<User>;
  resultsTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Varieties = {
  __typename?: 'Varieties';
  results: Array<Variety>;
};

export type Variety = {
  __typename?: 'Variety';
  grainType?: Maybe<GrainType>;
  id: Scalars['Int']['output'];
  isGrainHumidityAbsolute: Scalars['Boolean']['output'];
  locales: LocalesType;
  name: Scalars['String']['output'];
};

export type Versions = {
  __typename?: 'Versions';
  lastSupportedVersion: Scalars['String']['output'];
  latestVersion: Scalars['String']['output'];
};

export type WaterSurfaceMapIndex = {
  __typename?: 'WaterSurfaceMapIndex';
  /** unit: square meters */
  area?: Maybe<Scalars['Int']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  percentage?: Maybe<Scalars['Int']['output']>;
  provider: SentinelHubProvider;
  url?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
  weatherType?: Maybe<WeatherType>;
};

export type Weather = {
  __typename?: 'Weather';
  days?: Maybe<Array<WeatherDay>>;
};

export type WeatherDay = {
  __typename?: 'WeatherDay';
  cloudCover?: Maybe<Scalars['Float']['output']>;
  dateTime: Scalars['String']['output'];
  precipProb?: Maybe<Scalars['Float']['output']>;
  tempMax: Scalars['Float']['output'];
  tempMin: Scalars['Float']['output'];
};

export enum WeatherType {
  CIRRUS = 'CIRRUS',
  CLEAR = 'CLEAR',
  CLOUDY = 'CLOUDY',
  PARTIALLY_CLOUDED = 'PARTIALLY_CLOUDED',
  PARTIALLY_CLOUDED_WITH_CIRRUS = 'PARTIALLY_CLOUDED_WITH_CIRRUS'
}

export type YearMonthRange = {
  /** e.g. 2024-01 */
  from: Scalars['String']['input'];
  /** e.g. 2024-06 */
  to: Scalars['String']['input'];
};
